<h2 class="text-center text-2xl font-semibold text-gray-900">Credit Card Information</h2>
<!-- <ng-template #content> -->

<form [formGroup]="creditCardInfoForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
    <p class="text-center text-gray-600 text-lg">
        Add your payment information now to speed up the checkout process and avoid having to enter it later—making
        your
        purchase quick and easy!
    </p>
    <div>
        <label for="cardHolder" class="font-mulish text-base">Card Holder Name</label>
        <input id="cardHolder" formControlName="cardHolder" class="p-inputtext w-full border rounded-md px-3 py-2" />
        <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('cardHolder') }">
            {{ getFieldError('cardHolder') || '' }}
        </small>
    </div>
    <div>
        <label for="cardNumber" class="font-mulish text-base">Credit Card Number </label>
        <input id="cardNumber" formControlName="cardNumber" class="p-inputtext w-full border rounded-md px-3 py-2"
            (input)=" onCardNumberInput($event)" />
        <div *ngIf="apiResponseError && !getFieldError('cardNumber')"
            class="text-red-500 block min-h-[1rem] text-[12px]">
            {{apiResponseError}}
        </div>
        <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('cardNumber') }">
            {{ getFieldError('cardNumber') || '' }}
        </small>


    </div>

    <div class="flex flex-col sm:flex-row gap-4">
        <!-- Expiration Date -->
        <div class="flex flex-col sm:flex-1">
            <label for="expirationMonth" class="font-mulish text-base">Expiration Date</label>
            <div class="flex gap-2">
                <p-select id="expirationMonth" formControlName="expirationMonth" placeholder=" Month"
                    class="w-full text-sm" [options]="months"></p-select>
                <p-select id="expirationYear" formControlName="expirationYear" placeholder="Year" [options]="years"
                    class="w-full text-sm"></p-select>
            </div>
            <small class="text-red-500 block min-h-[1rem]"
                [ngClass]="{ 'invisible': !getFieldError('expirationYear') }">
                {{ getFieldError('expirationYear') || '' }}
            </small>

            <small *ngIf="expirationError" class="text-red-500 block min-h-[1rem]">
                {{ expirationError }}
            </small>

        </div>



        <div class="flex flex-col sm:flex-1">
            <label for="country" class="font-mulish text-base">Country</label>
            <p-select id="country" formControlName="country" placeholder="" class="w-full text-sm" optionLabel="name"
                optionValue="abbreviation" [options]="countries"></p-select>
            <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('country') }">
                {{ getFieldError('country') || '' }}
            </small>
        </div>
    </div>

    <div>
        <label for="billingAddress" class="font-mulish text-base">Billing Address</label>
        <input id="billingAddress" formControlName="billingAddress"
            class="p-inputtext w-full mt-1 border rounded-md py-2 text-sm " />
        <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('billingAddress') }">
            {{ getFieldError('billingAddress') || '' }}
        </small>
    </div>

    <div class="flex flex-col sm:flex-row gap-1 ">

        <div class="flex flex-1 gap-1">
            <div class="flex-1">
                <label for="zipCode" class="font-mulish text-base">{{labelPostalCode}}</label>
                <input id="zipCode" formControlName="zipCode"
                    class="p-inputtext w-full text-sm  border rounded-md px-3 py-2" />
                <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('zipCode') }">
                    {{ getFieldError('zipCode') || '' }}
                </small>
            </div>

            <div class="flex-1">
                <label for="city" class="font-mulish text-base">City</label>
                <input id="city" formControlName="city"
                    class="p-inputtext w-full border text-sm  rounded-md px-3 py-2" />
                <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('city') }">
                    {{ getFieldError('city') || '' }}
                </small>
            </div>
        </div>
        <div class="flex-1">
            <label for="state" class="font-mulish text-base">{{labelState}}</label>

            <ng-container *ngIf="states.length > 0; else stateTextInput">
                <p-select id="state" formControlName="state" class="w-full text-sm" [options]="states"
                    optionLabel="name" optionValue="abbreviation" placeholder="{{placeHolderState}}">
                </p-select>
            </ng-container>

            <ng-template #stateTextInput>
                <input id="state" type="text" formControlName="state" class="p-inputtext p-component w-full text-sm"
                    placeholder="Enter your region" />
            </ng-template>

            <small class="text-red-500 block min-h-[1rem]" [ngClass]="{ 'invisible': !getFieldError('state') }">
                {{ getFieldError('state') || '' }}
            </small>
        </div>

    </div>

    <div class="flex justify-between w-full gap-4 mt-4">
        <button pButton type="button" label="Skip" (click)="onSkip()"
            class="h-[35px] !bg-white  px-6 py-2  w-1/2 text-base"
            [ngClass]="isCommunity ? '!border-[var(--dark-blue)] !text-[var(--dark-blue)]' : ' !border-[var(--p-info-500)] !text-[var(--p-info-500)]' "
            [rounded]="true"></button>
        <button pButton class=" h-[35px]  rounded-m relative flex items-center justify-center w-1/2"
            [rounded]="true">
            <i class="pi pi-save left-3">
            </i>
            <span class="font-semibold text-center w-full text-base !!text-[var(--p-text-color-primary)]] ">
                Save
            </span>
        </button>

    </div>
    <!-- <div *ngIf="apiResponseError " class="text-red-500 block min-h-[1rem] text-[12px]">
        {{apiResponseError}}
    </div> -->



</form>
<!-- </ng-template> -->

<ng-container *ngIf="isLoading">


    <div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
</ng-container>